import * as React from "react";
import { SVGProps, memo } from "react";

const HeadingS = (props: SVGProps<SVGSVGElement> & { slot?: string }) => <svg width={24} height={24} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}><path d="M8 9H9.42857V7.5H11.7514L9.91429 16.5H8V18H13.7143V16.5H12.1057L13.9429 7.5H16.5714V9H18V6H8V9Z" fill="currentColor" /></svg>;

const Memo = memo(HeadingS);
export default Memo;